import { predefinedEnvironments } from '@shared/schema/environments.js';

/*
 * The environment rows the settings page renders.
 *
 * `isPredefined` is DERIVED here rather than read from the row. The seeded read adds the field, a
 * freshly created row from the POST response does not, and a page that trusted the field would show a
 * new environment as renameable in one render and not the next. The names are the contract
 * (`predefinedEnvironments`), so deriving is also what agrees with the server, which refuses to rename
 * or delete a predefined environment by name.
 *
 * `workflowCount` counts GRAVITY workflows (from `workflow_schedule.environment_ids`) and
 * `pieveWorkflowCount` counts Pieve ones. The page needs "is it in use at all", so they are summed
 * into `usageCount` — a user deciding whether to delete does not care which product holds it.
 *
 * Production first, then Sandbox, then the rest by name: the same order the org settings list uses, so
 * an environment does not move when it is renamed.
 */
const PREDEFINED_NAMES = predefinedEnvironments.map((environment) => environment.name);

const getPredefinedRank = (name) => {
  const rank = PREDEFINED_NAMES.indexOf(name);

  return rank === -1 ? PREDEFINED_NAMES.length : rank;
};

const buildCompanyEnvironmentRows = ({ environments }) => {
  return (Array.isArray(environments) ? environments : [])
    .filter((environment) => environment?.id)
    .map((environment) => {
      const name = String(environment.name || '').trim();

      return {
        id: environment.id,
        name,
        isDefault: environment.isDefault === true,
        isPredefined: PREDEFINED_NAMES.includes(name),
        usageCount: (Number(environment.workflowCount) || 0) + (Number(environment.pieveWorkflowCount) || 0)
      };
    })
    .sort((left, right) => {
      const rankCompare = getPredefinedRank(left.name) - getPredefinedRank(right.name);

      return rankCompare !== 0 ? rankCompare : left.name.localeCompare(right.name);
    });
};

export default buildCompanyEnvironmentRows;
